import {Inject, Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {OKTA_AUTH} from "@okta/okta-angular";
import {OktaAuth} from "@okta/okta-auth-js";

@Injectable()
export class OktaAuthGuard implements CanActivate {

	constructor(
		@Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
		private router: Router
	) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<boolean | UrlTree> {
		return this.oktaAuth.isAuthenticated().then((isAuthenticated) => {
			if (isAuthenticated) {
				return true;
			}
			return this.router.parseUrl("/login");
		});
	}
}
